import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc CSrOrderListNotesWorkLineItem defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CSrOrderListNotesWorkLineItemService } from 'services/cSROrderListNotesWorkLineItem';
 *
 * // create service instance and send/cancel request
 * const cSrOrderListNotesWorkLineItemService = new CSrOrderListNotesWorkLineItemService();
 * const result = await cSrOrderListNotesWorkLineItemService.fetchData( '<user-id>' ); // fetch data
 * cSrOrderListNotesWorkLineItemService.cancel(); // cancel an active request
 */
export class CSrOrderListNotesWorkLineItemService extends HttpService {

    // make request and fetch data
    // make request and fetch data
    async fetchData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            const items = get( response, 'body.component.data.state.items', '' );
            const displayDateText = get( response, 'body.component.structure.displayDateText', '' );
            const actions = get( response, 'body.component.structure.actions', '' );
            const visibility = get( response, 'body.component.visibility', '' );
        
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    items,
                    displayDateText,
                    actions: getVisibleItems( actions, visibility )
                },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
